import React from 'react';

export default class CancelButton extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		// console.log("CancelButton", this.props)
		return (
			<button
				type="button"
				className="max-w-md my-3 border border-black bg-white shadow rounded-full text-center"
			>
				<p className="text-lg py-2 px-8 text-black">{this.props.label}</p>
			</button>
		);
	}
}
